// extracted by mini-css-extract-plugin
export default {"timelineRowItem":"TimelineRow-module__timelineRowItem--EN_EF","timelineRowBadge":"TimelineRow-module__timelineRowBadge--Lyy1u"};